import {BaseFormModel} from './base-form-model';

export class JavascriptLog extends BaseFormModel<JavascriptLog> {
    id: number;
    organizationId: number;
    origin: string;
    action: string;
    actionDate: Date;
    message: string;
    success: boolean;
}
